// extracted by mini-css-extract-plugin
module.exports = {"appUpdateToast":"AppUpdateToast_appUpdateToast__3u1n4","info":"AppUpdateToast_info__3bWzI","updateButton":"AppUpdateToast_updateButton__1MxPj"};